import { requestAIBot,requestAIBotDataReader } from '../config/auth';
import {
	aiBotOKRDataReader,
	aiBotLogin,

} from '../config/api-url';

export const aiBotOKRDataReaderAPI = (data) => requestAIBotDataReader(`${aiBotOKRDataReader}`, data, 'POST', "https://infoprolearning.unlocku.com/");

export const aiAuthorLoginAPI = (data) => requestAIBot(`${aiBotLogin}`, data, 'POST', 'https://aiauthor-dev.unlocku.com');